/**
 * ODC newsletter signup
 * Handles both the homepage section and the footer module.
 * Posts to Klaviyo's Client API and stores the list ID on the parent container.
 *
 * Install: Assets folder > Add a new asset > odc-newsletter.js
 *
 * IMPORTANT: this uses Klaviyo's legacy hosted subscribe endpoint, which
 * works without an API key from the browser. If you want to use the newer
 * /client/subscriptions/ endpoint instead, you'll need your Klaviyo Public
 * API Key (the 6-character one that starts with a letter). Drop it in
 * KLAVIYO_COMPANY_ID below.
 */
(function () {
  if (window.__odcNewsletterInit) return;
  window.__odcNewsletterInit = true;

  // OPTIONAL: paste your Klaviyo Public API key here to use the modern endpoint.
  // Find it in Klaviyo: Account > Settings > API Keys > Public API Key.
  // Leave blank to use the legacy hosted endpoint.
  var KLAVIYO_COMPANY_ID = '';

  function findListId(form) {
    var container = form.closest('[data-klaviyo-list]');
    return container ? container.getAttribute('data-klaviyo-list') : '';
  }

  function setState(form, state, text) {
    var msg = form.querySelector('[data-odc-message]');
    if (msg) {
      msg.textContent = text || '';
      if (state) msg.setAttribute('data-state', state);
      else msg.removeAttribute('data-state');
    }
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    var label = btn.querySelector('[data-button-label]');
    var loading = btn.querySelector('[data-button-loading]');
    if (state === 'loading') {
      btn.disabled = true;
      if (label) label.hidden = true;
      if (loading) loading.hidden = false;
    } else {
      btn.disabled = false;
      if (label) label.hidden = false;
      if (loading) loading.hidden = true;
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
  }

  function submitLegacy(listId, email) {
    var body = new URLSearchParams();
    body.append('g', listId);
    body.append('email', email);
    body.append('$fields', 'email');

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function submitModern(companyId, listId, email) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Open Day Starter Kit',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: '2024-10-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (r) {
      return { ok: r.status >= 200 && r.status < 300 };
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var emailInput = form.querySelector('input[name="email"]');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!isValidEmail(email)) {
      setState(form, 'error', 'please enter a valid email.');
      return;
    }

    var listId = findListId(form);
    if (!listId) {
      setState(form, 'error', 'sign-up unavailable. please try again later.');
      console.warn('[ODC] Missing Klaviyo list ID on form.');
      return;
    }

    setState(form, 'loading', 'sending the starter kit…');

    var request = KLAVIYO_COMPANY_ID
      ? submitModern(KLAVIYO_COMPANY_ID, listId, email)
      : submitLegacy(listId, email);

    request
      .then(function (result) {
        var success = KLAVIYO_COMPANY_ID
          ? !!(result && result.ok)
          : !!(result && (result.success || result.data === true || result.data === undefined && !result.errors));
        if (success) {
          form.reset();
          setState(form, 'success', "you're in. check your inbox for the starter kit. 🖊️");
          // Optional: fire a custom analytics event
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({ event: 'odc_newsletter_signup', list_id: listId });
          }
        } else {
          setState(form, 'error', 'something went wrong. please try again.');
        }
      })
      .catch(function () {
        setState(form, 'error', 'something went wrong. please try again.');
      });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-odc-newsletter]');
    forms.forEach(function (form) {
      if (form.dataset.odcBound) return;
      form.dataset.odcBound = 'true';
      form.addEventListener('submit', handleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();